module.exports = __webpack_public_path__ + "img/T5-B-xh0.3f327f34.png";